<div>
    <div class="row mt-3">
        <h6 class="col-10 pl-4">{{ 'reservation-button-text' | translate }}</h6>
        <div class="col-2 pr-4 text-right">
            <app-pagination [translations]="translations"
                (filteredTranslationsEmitter)="getFilteredTranslations($event)">
            </app-pagination>
        </div>
    </div>

    <div *ngIf="devices" class="card-body">
        <div class="row">
            <div class="col-4">
                <p class="font-weight-bold">{{ getLocaleName(locationLocaleMain) | translate }}</p>
                <div *ngFor="let device of devices" class="form-group">
                    <p>{{ device.deviceName }}</p>
                    <div class="input-group">
                        <input disabled [(ngModel)]="device.reservationButtonText" class="form-control">
                    </div>
                    <hr>
                </div>
            </div>

            <div class="col-4" *ngFor="let translation of deleteLocaleMain(isOnPage()); let i = index">
                <form *ngIf="reservationButtonTextTranslations[startIndex + i]" #form="ngForm" autocomplete="off">
                    <p class="font-weight-bold">{{ getLocaleName(translation.locale) | translate }}</p>
                    <div *ngFor="let device of devices; let j = index" class="form-group">
                        <p>{{ device.deviceName }}</p>
                        <div class="input-group">
                            <input class="form-control" [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="reservationButtonTextTranslations[startIndex + i][j].translationValue">
                        </div>
                        <hr>
                    </div>
                </form>
            </div>
        </div>
        <div class="form-group">
            <app-submit-button (click)="onSubmit()" type="submit" [loading]="formSubmitted"
                [text]="'save-reservation-button-text-translations' | translate">
            </app-submit-button>
        </div>

    </div>

</div>